var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"light-container"},_vm._l((_vm.lights),function(light){return _c('div',{key:light.id,staticClass:"light",class:{ on: light.on, off: !light.on }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }